<template>
  <div style="width: 100%; height: 100%; overflow: hidden; position: relative">
    <img
      style="width: 100%; height: 100%"
      src="~@/assets/images/loading-bg.png"
    />
    <div class="process">
      <div class="process-main">
        <div class="process-content process-width-height">
          <img
            class="process-width-height"
            src="~@/assets/images/loading-logo-2.png"
          />
          <div class="process-mask" :style="{ width: progress + '%' }">
            <img
              class="process-width-height"
              src="~@/assets/images/loading-logo-1.png"
            />
          </div>
        </div>
      </div>
      <div class="process-text">{{ progress }}%</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import {
  loadHomePage,
  loadIntroPage,
  loadGamePage,
  loadAboutPage,
  loadWorkPage,
  loadOtherPage,
} from "@/assets/js/preload";

const emits = defineEmits(["complete"]);

const progress = ref(0);
// 更新进度的函数
function updateProgress() {
  if (progress.value < 100) {
    progress.value += 1;
  } else {
    clearInterval(intervalId);
    emits("complete");
  }
}

let intervalId;

onMounted(() => {
  intervalId = setInterval(updateProgress, 26); // 每30毫秒更新一次进度，总计大约3秒完成
  loadHomePage();
  loadIntroPage();
  loadGamePage();
  loadAboutPage();
  loadWorkPage();
  loadOtherPage();
});

onUnmounted(() => {
  clearInterval(intervalId);
});
</script>

<style lang="scss" scoped>
.process {
  position: absolute;
  top: 26vh;
  width: 100%;

  .process-main {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;

    .process-content {
      position: relative;
      .process-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        transition: all 0.1s linear;

        // animation: loading-keyframe 3s linear;
        // @keyframes loading-keyframe {
        //   from {
        //     width: 0;
        //   }
        //   to {
        //     width: 100%;
        //   }
        // }
      }
    }
  }
  .process-width-height {
    width: 73.1481rem;
    height: 16.2037rem;
  }

  .process-text {
    margin-top: 4.4444rem;
    color: #a1c7f0;
    font-size: 5.3704rem;
    text-align: center;
  }
}
</style>